<template>
  <div class="mt-2" style="min-height: 100vh;">
    <div class="row">
      <div class="col-12">
        <h1 class="font-weight-bold text-uppercase ml-2" id="inicio">Realizar Orçamento</h1>
      </div>
      <hr class="linha-amarela ml-2" />
    </div>
    <div class="d-flex justify-content-end">
      <b-button 
        class="mr-3" 
        variant="danger"
        @click="$refs.videoManual.toggleOpen({ 
          url: 'https://www.youtube.com/watch?v=04JWo6JBNmw&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=28', 
          title: 'Realizar Orçamento' 
        })"
      >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
    </div>
    <div class="row mt-3">
      <div class="col-md-8">
        <label for="email" class="font-weight-bold">{{tipoBuscaCliente == 'email' ? 'Nome/E-mail:' : 'CPF/CNPJ'}}</label><br/>
        <input 
          @keyup.enter="buscarCliente()" 
          type="text" 
          class="form-control" 
          v-model="emailBusca" 
          :placeholder="tipoBuscaCliente == 'email' ? 'Nome, E-mail' : 'CPF/CNPJ'"
          :maxlength="tipoBuscaCliente == 'email' ? '255' : '18'"
        >

        <button class="btn-search" @click="buscarCliente()">
          <i class="fas fa-search fa-2x c-orange mr-2"></i>
        </button>

        <input type="radio" name="buscarCliente" @click="tipoBuscaCliente = 'email', emailBusca = ''" :checked="tipoBuscaCliente == 'email'">
        <label class="ml-1 mr-4">Nome / E-mail</label>
        <input type="radio" name="buscarCliente" @click="tipoBuscaCliente = 'cpf_cnpj', emailBusca = ''">
        <label class="ml-1 mr-4">CPF / CNPJ</label>
        <input type="radio" name="buscarCliente" @click="buscarCliente(true)">
        <label class="ml-1">Cliente sem cadastro</label>
      </div>

      <div class="col-md-4" v-if="dados.email != null">
        <label for="email" class="font-weight-bold">E-mail selecionado:</label>
        <span class="limparOrcamento" @click="limparOrcamento(), emailBusca = ''">limpar orçamento</span>
        <br/>
        <input type="text" class="form-control" :value="dados.email == 'orcamentosemcliente@gmail.com' ? 'Cliente sem cadastro' : dados.email" readonly/>
      </div>

      <div class="col-md-4 text-right alingImg" v-if="dados.email == null">
        <button class="btn-add-cliente" @click="addCliente(true)">Adicionar cliente</button>
      </div>
    </div>

    <hr>

    <div class="row mb-4" v-if="dados.email != null">
      <div class="col-md-12">
        <h4 class="text-center fs-24 bg-light p-3">ITENS DO ORÇAMENTO</h4>
      </div>

      <div class="col-md-12" v-if="produtos.length > 0">
        <div class="row" v-for="(item, i) in produtos" :key="i">

          <div class="col-md-10">
            <label class="itemList">Item {{i+1}}</label>
            <input 
              v-if="produtos[i].img"
              type="text" 
              class="form-control cursor-pointer" 
              v-model="item.product" 
              @click="modalBucarProdutos(), 
              iSelected = i" 
              placeholder="Selecione um produto"
              @keydown.enter="handleEnterKey($event)"
            >

            <div 
              v-else
              type="text" 
              class="form-control cursor-pointer input-select" 
              @click="modalBucarProdutos(), 
              iSelected = i" 
            >Selecione um produto</div>
          </div>

          <div class="col-md-2 mt-2">
            <label>Cód. interno</label>
            <input type="number" v-mask="['##########']" class="form-control cursor-pointer" @keydown.enter="buscarProdutoCod(produtos[i].cod_int), iSelected = i" @keyup.enter="handleEnterKey($event)" v-model="produtos[i].cod_int"  placeholder="Ex: 0005" @blur="buscarProdutoCod(produtos[i].cod_int), iSelected = i">
          </div>

          <div class="col-md-2 alingImg mt-2">
            <img :src="formatImg(produtos[i].origem, produtos[i].img)" :alt="produtos[i].product" style="width: 100px">
          </div>

          <div class="col-md-3 mt-2">
            <label>Cód. barras:</label><span class="opcional">Opcional</span>
            <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-mask="['#############']" v-model="produtos[i].bar_code" :readonly="produtos[i].product_id != null">
          </div>

          <div class="col-md-3 mt-2">
            <label>Tipo de venda:</label><span class="opcional">Opcional</span>
            <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-model="produtos[i].unidade" :readonly="produtos[i].product_id != null" placeholder="Ex: Un, Mt.">
          </div>

          <div class="col-md-4 mt-2">
            <label>Marca:</label><span class="opcional">Opcional</span>
            <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-model="produtos[i].marca" :readonly="produtos[i].product_id != null">
          </div>

          <div class="col-md-2 mt-2">
            <label>Quantidade:</label>
            <input type="number" v-mask="['######']" @keydown.enter="handleEnterKey($event)" @blur="validQtd(i)" class="form-control" v-model="produtos[i].qtd">
          </div>

          <div class="col-md-2 mt-2">
            <label>Preço unitário:</label>
            <div class="input-group">
              <div class="input-group-append">
                <span class="input-group-text" id="">R$</span>
              </div>
              <input 
                type="text" 
                :class="produtos[i].price == '0,00' ? 'form-control required' : 'form-control'" 
                v-model="produtos[i].price" 
                v-money="money" 
                @blur="validPrice(i)" 
                @keyup.enter="removeSpecialChars($event)" 
                @keydown.enter="handleEnterKey($event)" 
              >
            </div>
          </div>

          <div class="col-md-2 mt-2">
            <label>Subtotal:</label>
            <div class="input-group">
              <div class="input-group-append">
                <span class="input-group-text" id="">R$</span>
              </div>
              <input type="text" class="form-control" v-model="produtos[i].subtotal" v-money="money" readonly @keydown.enter="handleEnterKey($event)">
            </div>
            
          </div>

          <div class="col-md-2 mt-2">
            <label>Cliente pode alterar a QTD?:</label><br>
            <input type="checkbox" v-model="produtos[i].altQtd" @keydown.enter="handleEnterKey($event)">{{produtos[i].altQtd == true ? ' Sim' : ' Não'}}     
          </div>

          <div class="col-md-2 mt-2">
            <label>Qtd. maxima:</label>
            <input type="number" class="form-control" v-model="produtos[i].qtdMax" :disabled="produtos[i].altQtd == false" @keydown.enter="handleEnterKey($event)">    
          </div>

          <div class="col-md-2 mt-2 alinharCentro">
            <button :class="produtos.length == 1 ? 'btn-trash-item-disabled' : 'btn-trash-item'" @click="deleteItem(i)"><i class="fas fa-trash"></i> Remover</button>
          </div>

          <div class="col-md-12 ">
            <hr>
          </div>

        </div>
      </div>

      <div class="col-md-12" v-else>
        <div class="alert alert-warning" role="alert">
          Sem produtos selecionados
        </div>
      </div>

      <div class="col-md-12 text-center mt-2">
        <button class="btn-add-item mr-2" @click="adicionarProduto()">
          <i class="fas fa-plus"></i> Adicionar novo item
        </button>
      </div>

      <div class="col-md-12 mt-4">
        <h4 class="text-center fs-24 bg-light p-3">MEIOS DE ENTREGA</h4>      
      </div>

      <div class="col-md-12">
        <div class="row">
          <div class="col-md-2">
            <label>Retira na loja?</label><br>
            <label>
              <input type="checkbox" v-model="dados.oPFrete.retiraLoja" @keydown.enter="handleEnterKey($event)"> {{dados.oPFrete.retiraLoja == true ? 'Sim' : 'Não'}}
            </label>  
          </div>

          <div class="col-md-3">
            <label>Prazo para retirada em loja após o pagamento:</label><br>
            <div>
              <input type="number" @keydown.enter="handleEnterKey($event)" placeholder="Ex: 2" :class="error.retiraLojaD == true ? 'form-control required' : 'form-control'" v-model="dados.oPFrete.retiraLojaD" :disabled="dados.oPFrete.retiraLoja == false" style="width: 50%; float: left;">
              <select name="select" :class="error.retiraLojaT == true ? 'form-control required' : 'form-control'" v-model="dados.oPFrete.retiraLojaT" :disabled="dados.oPFrete.retiraLoja == false" style="width: 50%;">
                <option value="hora(s)">Hora(s)</option>
                <option value="dia(s)">Dia(s)</option>
              </select>
            </div>
          </div>

          <div class="col-md-2 text-right">
            <label>Loja entrega?</label><br>
            <label style="margin-right: 21%;">
              <input type="checkbox" v-model="dados.oPFrete.entrega" @keydown.enter="handleEnterKey($event)"> {{dados.oPFrete.entrega == true ? 'Sim' : 'Não'}}
            </label>  
          </div>

          <div class="col-md-3">
            <label>Prazo para entrega após o pagamento:</label><br>
            <div>
              <input type="number" @keydown.enter="handleEnterKey($event)" placeholder="Ex: 2" :class="error.entregaD == true ? 'form-control required' : 'form-control'" v-model="dados.oPFrete.entregaD" :disabled="dados.oPFrete.entrega == false" style="width: 50%; float: left;">
              <select name="select" :class="error.entregaT == true ? 'form-control required' : 'form-control'" v-model="dados.oPFrete.entregaT" :disabled="dados.oPFrete.entrega == false" style="width: 50%;">
                <option value="hora(s)">Hora(s)</option>
                <option value="dia(s)">Dia(s)</option>
              </select>
            </div>
          </div>

          <div class="col-md-2">
            <label>Valor do frete:</label>
            <span class="opcional" v-if="dados.oPFrete.valorFrete == '0,00' && dados.oPFrete.entrega == true">Frete grátis</span>
            <span class="opcional" v-if="dados.oPFrete.valorFrete != '0,00' && dados.oPFrete.entrega == true">{{dados.oPFrete.valorFrete}}</span>
            <div class="input-group">
              <div class="input-group-append">
                <span class="input-group-text" id="">R$</span>
              </div>
              <input type="text" placeholder="R$ 0,00" class="form-control" v-model="dados.oPFrete.valorFrete" v-money="money" @keydown.enter="handleEnterKey($event)" @blur="somaTotal()" :disabled="dados.oPFrete.entrega == false">
            </div>
          </div>

          <div class="col-md-12 mt-2" v-if="dados.oPFrete.entrega == true">
            <h4 class="text-center fs-24 bg-light p-3 mt-4">ENDEREÇO DE ENTREGA</h4>
            <div class="row">
              <div class="col-md-3">
                <label>CEP:</label>
                <input 
                  type="text" 
                  :class="dados.oPFrete.cep == null ||  dados.oPFrete.cep == ''? 'form-control required' : 'form-control'" 
                  placeholder="#####-###" 
                  v-mask="'#####-###'" 
                  v-model="dados.oPFrete.cep" 
                  @blur="buscarCep()"
                  @keydown.enter="handleEnterKey($event)"
                >
              </div>

              <div class="col-md-9">
                <label>Endereço:</label>
                <input 
                  type="text" 
                  :class="dados.oPFrete.endereco == null ||  dados.oPFrete.endereco == ''? 'form-control required' : 'form-control'"  
                  placeholder="Endereço de entrega" 
                  v-model="dados.oPFrete.endereco"
                  @keydown.enter="handleEnterKey($event)"
                >
              </div>

              <div class="col-md-4 mt-2">
                <label>Bairro:</label>
                <input 
                  type="text" 
                  :class="dados.oPFrete.bairro == null ||  dados.oPFrete.bairro == ''? 'form-control required' : 'form-control'" 
                  placeholder="Bairro de entrega" 
                  v-model="dados.oPFrete.bairro"
                  @keydown.enter="handleEnterKey($event)"
                >
              </div>

              <div class="col-md-2 mt-2">
                <label>Nº:</label>
                <input 
                  type="text" 
                  :class="dados.oPFrete.numero == null ||  dados.oPFrete.numero == ''? 'form-control required' : 'form-control'" 
                  placeholder="Número" 
                  v-model="dados.oPFrete.numero"
                  @keydown.enter="handleEnterKey($event)"
                >
              </div>

               <div class="col-md-3 mt-2">
                <label>Complemento:</label>
                <input 
                  type="text" 
                  class="form-control" 
                  placeholder="Ex: Casa, loja, Ap 03" 
                  v-model="dados.oPFrete.complemento"
                  @keydown.enter="handleEnterKey($event)"
                >
              </div>

              <div class="col-md-2 mt-2">
                <label>Cidade:</label>
                <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" placeholder="Cidade de entrega" v-model="dados.oPFrete.cidade" disabled>
              </div>

              <div class="col-md-1 mt-2">
                <label>UF:</label>
                <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" placeholder="UF" v-model="dados.oPFrete.uf" disabled>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 mt-4">
          <h4 class="text-center fs-24 bg-light p-3 cursor-pointer" @click="isHide = !isHide">
            CALCULADORA DE RECEBIMENTO
            <i v-if="isHide" class="fa fa-sort-down fs-24 arrow-line-down"></i>
            <i v-else class="fa fa-sort-up fs-24 arrow-line-up"></i>
          </h4>
      </div>
      
      <div class="col-md-12 mt-4" v-if="isHide">

        <p class="text-center">Simule abaixo os valores a receber, de acordo com a forma de pagamento escolhida!</p>
        <div class="row">
          <div class="col-md-12">
            <h4>Pix</h4>  
          </div>

          <div class="col-md-3">
            <b class="text-uppercase px-2 fs-14">% Desconto:</b>
            <i class="fas fa-question-circle question-tool-tips" id="descontoPix"></i>

            <b-tooltip target="descontoPix">Trata-se do valor porcentual e opcional para oferecer desconto sobre o valor integral do orçamento</b-tooltip>

            <div class="input-group">
              <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-mask="['#.##', '##.##']" v-model="desconto.pix"/>
              <div class="input-group-append">
                <span class="input-group-text" id="">%</span>
              </div>
            </div>
          </div>  

          <div class="col-md-3">
            <b class="text-uppercase fs-14">Taxa Transação:</b>
            <i class="fas fa-question-circle question-tool-tips" id="taxaTransacao"></i>
            <b-tooltip target="taxaTransacao">Trata-se da taxa fixa por transação de R$ 0,50 da plataforma de pagamento (Iugu)</b-tooltip>
            <input class="form-control text-center" @keydown.enter="handleEnterKey($event)" type="text" readonly v-model="taxa.pix">
          </div>

          <div class="col-md-3">
            <b class="text-uppercase fs-14">Valor a receber:</b>
            <i class="fas fa-question-circle question-tool-tips" id="liquido"></i>
            <b-tooltip target="liquido">Trata-se do valor à receber líquido</b-tooltip>
            <input class="form-control text-center" @keydown.enter="handleEnterKey($event)" type="text" v-model="pixTotal" readonly>
          </div>  

          <div class="col-md-12 mt-4">
            <h4>Boleto</h4>  
          </div>

          <div class="col-md-3">
            <b class="text-uppercase fs-14">% Desconto:</b>
            <i class="fas fa-question-circle question-tool-tips" id="descontoBoleto"></i>

            <b-tooltip target="descontoBoleto">Trata-se do valor porcentual e opcional para oferecer desconto sobre o valor integral do orçamento</b-tooltip>

            <div class="input-group">
              <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-mask="['#.##', '##.##']" v-model="desconto.boleto">
              <div class="input-group-append">
                <span class="input-group-text" id="">%</span>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <b class="text-uppercase fs-14">Taxa Transação:</b>
            <i class="fas fa-question-circle question-tool-tips" id="taxaTransacaoBoleto"></i>

            <b-tooltip target="taxaTransacaoBoleto">Trata-se da taxa fixa por transação de R$ 1,89 da plataforma de pagamento (Iugu)</b-tooltip>
            <input class="form-control text-center" @keydown.enter="handleEnterKey($event)" type="text" v-model="taxa.boleto" readonly>
          </div>

          <div class="col-md-3">
            <b class="text-uppercase fs-14">Valor a receber:</b>
            <i class="fas fa-question-circle question-tool-tips" id="liquidoBoleto"></i>
            <b-tooltip target="liquidoBoleto">Trata-se do valor à receber líquido</b-tooltip>
            <input class="form-control text-center" @keydown.enter="handleEnterKey($event)" type="text" v-model="boletoTotal" readonly>
          </div>

          <div class="col-md-12 mt-4">
            <h4>Cartão de credito</h4>  
          </div>

          <div class="col-md-3">
            <b class="text-uppercase fs-14">Parcelas até:</b>
              <i class="fas fa-question-circle question-tool-tips" id="simulaParcelas"></i>
              <b-tooltip target="simulaParcelas">Trata-se no número máximo de parcelas que sua loja pretende disponibilizar para pagamento</b-tooltip>
              <select class="form-control" v-model="totalParcelas" @click="selectQtdParcelas()">
                <option value="1">1x</option>
                <option value="2">2x</option>
                <option value="3">3x</option>
                <option value="4">4x</option>
                <option value="5">5x</option>
                <option value="6">6x</option>
                <option value="7">7x</option>
                <option value="8">8x</option>
                <option value="9">9x</option>
                <option value="10">10x</option>
                <option value="11">11x</option>
                <option value="12">12x</option>
              </select>
          </div>

          <div class="col-md-2">
            <b class="text-uppercase fs-14">Taxa Transação:</b>
            <i class="fas fa-question-circle question-tool-tips" id="taxaTransacaoCartao"></i>
            <b-tooltip target="taxaTransacaoCartao">Trata-se da taxa fixa por transação (R$ 0,30) + 2,35% ao mês da taxa da plataforma de pagamento (Iugu)</b-tooltip>
            <input class="form-control text-center" @keydown.enter="handleEnterKey($event)" type="text" v-model="taxa.cartao" readonly>
          </div>

          <div class="col-md-2">
            <b class="text-uppercase fs-14">Valor a Receber:</b>
            <i class="fas fa-question-circle question-tool-tips" id="liquidoCartao"></i>
            <b-tooltip target="liquidoCartao">Trata-se do valor à receber líquido</b-tooltip>
            <input class="form-control text-center" @keydown.enter="handleEnterKey($event)" type="text" v-model="cartaoTotal" readonly>
          </div>

          <div class="col-md-2">
            <b class="text-uppercase fs-14">Valor Parcela:</b>
            <i class="fas fa-question-circle question-tool-tips" id="parcela"></i>
            <b-tooltip target="parcela">Trata-se do valor à receber mensal sem antecipação</b-tooltip>
            <input v-if="totalParcelas == 0" @keydown.enter="handleEnterKey($event)" class="form-control text-center" type="text" v-model="cartaoTotal" readonly>
            <input v-else @keydown.enter="handleEnterKey($event)" class="form-control text-center" type="text" v-model="cartaoParcelado" readonly>
          </div>
        </div>        
      </div>

      <div class="col-md-12 mt-4">
        <h4 class="text-center fs-24 bg-light p-3">MEIOS DE PAGAMENTO</h4>
        <p class="text-center">Configure as opções de pagamentos para seu cliente</p>           
      </div>

      <div class="col-md-12">
        <div class="row">
          <div class="col-md-3">
            <label class="form-check-label"> Pix:</label>
            <i class="fas fa-question-circle question-tool-tips" id="descontoPixCliente"></i>
            <b-tooltip target="descontoPixCliente">Trata-se do valor porcentual e opcional para oferecer desconto sobre o valor integral do orçamento</b-tooltip>

            <b class="text-uppercase px-2 fs-14 float-right">% Desconto:</b>

            <div :class="error.pagamento == true ? 'input-group required' : 'input-group'">
              <div class="input-group-append" style="margin-left: 0px;">
                <span class="input-group-text"><input id="checkboxPix" type="checkbox" @click="formPayments('P')"></span>
              </div>
              <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-mask="['#.##', '##.##']" v-model="desconto.pix" maxlength="5">
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-check-label"> Boleto:</label>
            <i class="fas fa-question-circle question-tool-tips" id="descontoBoletoCliente"></i>
            <b-tooltip target="descontoBoletoCliente">Trata-se do valor porcentual e opcional para oferecer desconto sobre o valor integral do orçamento</b-tooltip>

            <b class="text-uppercase px-2 fs-14 float-right">% Desconto:</b>

            <div :class="error.pagamento == true ? 'input-group required' : 'input-group'">
              <div class="input-group-append" style="margin-left: 0px;">
                <span class="input-group-text"><input id="checkboxBoleto" type="checkbox" @click="formPayments('B')"></span>
              </div>
              <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-mask="['#.##', '##.##']" v-model="desconto.boleto" maxlength="5">
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-check-label"> Cartão de credito:</label>
            <i class="fas fa-question-circle question-tool-tips" id="formaParcelas"></i>
            <b-tooltip target="formaParcelas">Trata-se no número máximo de parcelas que sua loja pretende disponibilizar para pagamento</b-tooltip>

            <div :class="error.pagamento == true ? 'input-group required' : 'input-group'">
              <div class="input-group-append" style="margin-left: 0px;">
                <span class="input-group-text"><input id="checkboxCartao" type="checkbox" @click="formPayments('C')"></span>
              </div>
              <select class="form-control" v-model="totalParcelas" @click="selectQtdParcelas()">
                <option value="1">1x</option>
                <option value="2">2x</option>
                <option value="3">3x</option>
                <option value="4">4x</option>
                <option value="5">5x</option>
                <option value="6">6x</option>
                <option value="7">7x</option>
                <option value="8">8x</option>
                <option value="9">9x</option>
                <option value="10">10x</option>
                <option value="11">11x</option>
                <option value="12">12x</option>
              </select>
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-check-label"> Pgto. na entrega:</label>
            <i class="fas fa-question-circle question-tool-tips" id="descontoRetirada"></i>
            <b-tooltip target="descontoRetirada">Trata-se do valor porcentual e opcional para oferecer desconto sobre o valor integral do orçamento</b-tooltip>

            <b class="text-uppercase px-2 fs-14 float-right">% Desconto:</b>

            <div :class="error.pagamento == true ? 'input-group required' : 'input-group'">
              <div class="input-group-append" style="margin-left: 0px;">
                <span class="input-group-text"><input id="checkboxEntrega" type="checkbox" @click="formPayments('E')"></span>
              </div>
              <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-mask="['#.##', '##.##']" v-model="desconto.entrega" maxlength="5">
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 mt-4">
        <h4 class="text-center fs-24 bg-light p-3">VALORES DO ORÇAMENTO</h4>           
      </div>
      
      <div class="col-md-4">
        <label>Orçamento criado por:</label>
        <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" :value="dadosUsuario.nome_usuario" disabled>
      </div>

      <div class="col-md-2">
        <label>Valor do frete:</label>
        <div class="input-group">
              <div class="input-group-append">
                <span class="input-group-text" id="">R$</span>
              </div>
              <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-money="money" :value="dados.oPFrete.valorFrete != null ? dados.oPFrete.valorFrete : null" disabled>
            </div>
      </div>

      <div class="col-md-2">
        <label>Subtotal:</label>
        <div class="input-group">
          <div class="input-group-append">
            <span class="input-group-text" id="">R$</span>
          </div>
          <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-money="money" :value="dados.oPgamento.subTotal != null ? dados.oPgamento.subTotal : null" disabled>
        </div>
      </div>

      <div class="col-md-2">
        <label>Total S/Frete:</label>
        <div class="input-group">
          <div class="input-group-append">
            <span class="input-group-text" id="">R$</span>
          </div>
          <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-money="money" :value="dados.oPgamento.subTotal != null ? dados.oPgamento.subTotal : null" disabled>
        </div>
      </div>

      <div class="col-md-2">
        <label>Total C/Frete:</label>
        <div class="input-group">
          <div class="input-group-append">
            <span class="input-group-text" id="">R$</span>
          </div>
          <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-money="money" :value="dados.oPgamento.total != null ? dados.oPgamento.total : null" disabled>
        </div>
      </div>

      <div class="col-md-12 mt-4">
        <h4 class="text-center fs-24 bg-light p-3">DETALHES DO ORÇAMENTO</h4>           
      </div>

      <!-- <div class="col-md-4 mt-2">
        <div>
          <label>Esse orçamento pode gerar:</label>
        </div>
        <div class="row">
          <span class="col-md-2">
            <img src="@/assets/img/coin-logo.png" class="size-img img-fluid rounded" alt="Constru Coin">
          </span>
          <span class="col-md  col-img">
            <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" :value="converterCoin(dados.oPgamento.subTotal)" disabled>
          </span>
        </div>
      </div> -->

      <div class="col-md mt-2">
        <label>Orçamento valido até:</label>
        <b-form-datepicker
          v-model="validOrcamentDate" 
          reset-button
          close-button
          today-button
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
          placeholder="Data"
          label-close-button="Fechar"
          label-today-button="Hoje"
          label-reset-button="Limpar"
          label-help=""
          locale="pt-BR"
        />
      </div>

      <div class="col-md mt-2">
        <b-form-timepicker 
          class="timer-heigth"
          v-model="validOrcamentHour" 
          locale="pt-BR"
          close-button
          now-button
          reset-button
          placeholder="Hora"
          label-close-button="Fechar"
          label-now-button="Agora"
          label-reset-button="Resetar"
        >
        </b-form-timepicker>
      </div>

      <div class="col-md-12 text-center mt-4">
        <button class="btn-finalizar" @click="finalizar()">
          <i class="fas fa-save mr-2"></i> Finalizar orçamento
        </button>
      </div>

    </div>

    <b-modal
      title="Buscar produtos"
      size="xl"
      id="modalBuscarProdutos"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-12">
          <b-form-group 
            label="Escolha o tipo de pesquisa, se em todo nosso banco de dados ou somente os produtos do lojista" 
            v-slot="{ ariaDescribedby }"
          >
            <b-form-radio-group
              id="btn-radios-1"
              v-model="typeSearch"
              :options="options"
              :aria-describedby="ariaDescribedby"
              button-variant="outline-primary"
              name="radios-btn-default"
              buttons
            ></b-form-radio-group>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <label>Buscar produto</label>
          <input type="text" @keydown.enter="handleEnterKey($event)" class="form-control" v-model="buscarProdutoItem" placeholder="Nome produto, cód. barras...">
          <span slot="no-options" class="opcionalSelect">Digite no mínimo 3 letras para pesquisar o item {{iSelected+1}}!</span>
        </div>

        <div class="col-md-12 mt-5">
          <table class="table table-striped table-bordered" v-if="itens != null">
            <thead>
              <tr>
                <th scope="col">Ação</th>
                <th scope="col">Imagem</th>
                <th scope="col">Produto</th>
                <th scope="col">Cód. barras</th>
                <th scope="col">Marca</th>
                <th scope="col">Tipo Un.</th>
                <th scope="col">Preço</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in itens" :key="i">
                <td class="text-center">
                  <span @click="formatItem(item)" class="btn-add-produto"><i class="fas fa-plus"></i></span>
                </td>
                <td class="text-center cursor-pointer">
                  <img 
                    @click="buscarDetalhesGerais(item.id, item.produto)"
                    :src="formatImg(item.origem, item.produto_fotos[0].foto_png)"
                    :alt="item.produto"
                    style="width: 40px"
                  >
                </td>
                <td>{{item.produto}}</td>
                <td>{{item.codbar}}</td>
                <td>{{item.marca}}</td>
                <td>{{item.unidade}}</td>
                <td>{{item.price_sales_format_1}}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </b-modal>

    <b-modal
      title="Selecione um cliente"
      size="xl"
      id="modalClientes"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-12 mt-5">
          <h4 class="mb-2">Selecione um cliente</h4>
          <table class="table table-striped table-bordered" v-if="clientes != null">
            <thead>
              <tr>
                <th scope="col">Nome</th>
                <th scope="col">E-mail</th>
                <th scope="col">CPF/CNPJ</th>
                <th scope="col" class="text-center">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in clientes" :key="i">
                <td>{{formatName(item)}}</td>
                <td>{{item.email}}</td>
                <td>{{item.cpf && item.cpf != '' ? item.cpf : item.cnpj}}</td>
                <td class="text-center">
                  <span @click="addClienteSearch(item)" class="btn-add-produto"><i class="fas fa-plus"></i></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Link de pagamento"
      size="md"
      id="linkPagamentoModal"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-12">
          <input type="text" class="form-control" :value="value" disabled>
        </div>
        
        <div class="col-md-12 text-center">
          <button class="btn-send-payment" @click="copyToClipboard()">Copiar link de pagamento</button>
        </div>
      </div>
    </b-modal>

    <b-modal
      :title="modalImgNome"
      size="xl"
      id="modalImgProduto"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-12">
          <img :src="modalImg" :alt="modalImgNome" class="modalImg">
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="detalhesProduto"
      size="xl"
      centered
      hide-footer
      :title="productModal"
      header-bg-variant="orange"
      header-text-variant="light"
    >
      <b-row>
        <b-col cols="5" class="slideImg">
          <b-carousel
            style="text-shadow: 0px 0px 2px #000"
            indicators
            img-width="600"
            img-height="600"
            controls
            sliding-start
            sliding-end
            v-if="detalhesP.fotos.length > 0"
          >
            <b-carousel-slide
              v-for="(item, i) in detalhesP.fotos"
              :key="i"
              :img-src="formatImg(detalhesP.produto.origem, item.foto_png)"
            ></b-carousel-slide>
          </b-carousel>

          <div v-else>
            <h1>Sem imagens</h1>
          </div>
        </b-col>

        <b-col cols="7">
          <div
            class="accordion"
            role="tablist"
            v-if="detalhesP.produto != null"
          >

            <b-card-header class="text-center">
                <h4>{{ detalhesP.produto.departamentos }}</h4>
            </b-card-header>
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-1 variant="success"
                  >Detalhes</b-button
                >
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <label>Produto:</label>
                      <input
                        type="text"
                        :value="detalhesP.produto.produto"
                        class="form-control"
                        readonly
                      />
                      <div v-if="productSelectedAt" class="fs-14 text-secondary">
                        (Selecionado em {{ productSelectedAt }})
                      </div>
                    </b-col>

                    <b-col cols="4" class="mb-2">
                      <label>Marca:</label>
                      <input
                        type="text"
                        :value="detalhesP.produto.marca"
                        class="form-control"
                        readonly
                      />
                    </b-col>

                    <b-col cols="4" class="mb-2">
                      <label>Cod. barras:</label>
                      <input
                        type="text"
                        :value="detalhesP.produto.codbar"
                        class="form-control"
                        readonly
                      />
                    </b-col>

                    <b-col cols="4" class="mb-2">
                      <label>{{
                        typeProducts == 'fixadores'
                          ? 'Un. estoque'
                          : 'Dimensões:'
                      }}</label>
                      <input
                        type="text"
                        :value="
                          typeProducts == 'fixadores'
                            ? detalhesP.produto.unidade
                            : detalhesP.produto.dimensoes
                        "
                        class="form-control"
                        readonly
                      />
                    </b-col>

                    <b-col cols="12" class="mb-2">
                      <label>Descrição:</label>
                      <textarea
                        type="text"
                        :value="detalhesP.produto.descricao"
                        class="form-control"
                        rows="3"
                        readonly
                      ></textarea>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1" v-if="detalhesP.fichas.length > 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-2 variant="info"
                  >Ficha técnica</b-button
                >
              </b-card-header>
              <b-collapse
                id="accordion-2"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body class="scrollDiv">
                  <b-row v-for="(item, i) in detalhesP.fichas" :key="i">
                    <b-col cols="4" class="mb-2">
                      <input
                        type="text"
                        :value="item.tipo"
                        class="form-control"
                        readonly
                      />
                    </b-col>

                    <b-col cols="8" class="mb-2">
                      <input
                        type="text"
                        :value="item.descricao"
                        class="form-control"
                        readonly
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Criar conta para cliente"
      size="md"
      id="novaContaCliente"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-6">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="Fields.nome" placeholder="Nome do cliente">
        </div>
        <div class="col-md-6">
          <label>Sobrenome</label>
          <input type="text" class="form-control" v-model="Fields.sobrenome" placeholder="Sobrenome do cliente">
        </div>
      </div>
      
      <div class="row mt-2">
        <div class="col-md-6">
          <label>CPF</label>
          <input type="text" class="form-control" v-model="Fields.cpf" v-mask="'###.###.###-##'" placeholder="###.###.###-##">
        </div>
        <div class="col-md-6">
          <label>WhastApp</label>
          <input type="text" class="form-control" v-model="Fields.whatsapp" v-mask="['(##) ####-####', '(##) # ####-####']" placeholder="(##) # ####-####">
        </div>
      </div>
      
      <div class="row mt-2">
        <div class="col-md-12">
          <label>E-mail</label>
          <input type="text" class="form-control" v-model="Fields.email" placeholder="emailcliente@email.com">
        </div>
      </div>
      
      <div class="row mt-4">
        <div class="col-md-12 text-center">
          <button class="btn-finalizar" @click="salvarCliente()">Salvar cliente</button>
        </div>
      </div>
    </b-modal>
    <VideoManual ref="videoManual"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from 'axios';
import makeToast from "../../mixins/makeToast";
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: "RealizarOrcamento",
  mixins: [makeToast],
  components: {
    VideoManual
  },
  data: () => ({
    isHide: false,
    modalImg: '',
    productModal: '',
    validOrcamentDate: '',
    validOrcamentHour:'',
    modalImgNome: '',
    emailBusca: '',
    tipoBuscaCliente: 'email',
    novaConta: false,
    desativarEmail: false,
    iSelected: null,
    request: null,
    buscarProdutoItem: '',
    search: '',
    value: '',
    produtos: [],
    clientes: [],
    itens: null,
    detalhesP: {
      fotos: [],
      fichas: [],
      produto: null,
    },
    dados: {
      email: null,
      user_id: null,
      lojista_id: null,
      balconista_id: null,
      validade:null,
      oPgamento: {
        total: null,
        subTotal: null,
        tipos: {},
      },
      oPFrete: {
        retiraLoja: false,
        retiraLojaD: null,
        retiraLojaT: null,
        entrega: false,
        entregaD: null,
        entregaT: null,
        valorFrete: null,
        cep: null,
        endereco: null,
        bairro: null,
        complemento: null,
        numero: null,
        cidade: null,
        uf: null,
      },
      itens: [],
    },
    Fields: {
      email: '',
      cpf: '',
      nome: '',
      sobrenome: '',
      whatsapp: '',
      clerk_id: null,
      contrup_lojista_id: null
    },
    boletoTotal: 0,
    pixTotal: 0,
    cartaoTotal: 0,
    totalParcelas: 0,
    cartaoParcelado: 0,
    pix: '',
    boleto: '',
    cartao: '',
    pagamentoEntrega: '',
    desconto: {
      pix: 0,
      boleto: 0,
      cartao: 0,
      entrega: 0,
    },
    taxa: {
      cartao: 0,
      boleto: 0,
      pix: 0,
    },
    money: {
      decimal: ',',
      thousands: '.',
      prefix: '',
      suffix: '',
      precision: 2,
      masked: true,
    },
    error: {
      retiraLojaT: false,
      retiraLojaD: false,
      entregaT: false,
      entregaD: false,
      cep: false,
      endereco: false,
      bairro: false,
      numero: false,
      pagamento: false
    },
    typeSearch: 'all',
    options: [
      { text: 'Todos', value: 'all' },
      { text: 'Lojista', value: 'shopkeeper' }
    ]
  }),
  computed: {
    ...mapState(['token', 'dadosUsuario'])
  },
  watch: {
    'emailBusca': function() {
      if(this.tipoBuscaCliente != 'email') {
        var value = this.emailBusca;
        if(value.length <= 14) {
            value = value.replace(/\D/g, '');
            value = value.replace(/(\d{3})(\d)/, '$1.$2');
            value = value.replace(/(\d{3})(\d)/, '$1.$2');
            value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        } else {
          value = value.replace(/\D/g, '');
          value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        }
        this.emailBusca = value;
      }
    },
    'buscarProdutoItem': function() {
      if(this.buscarProdutoItem.length >= 3) {
        this.buscarProduto(this.buscarProdutoItem);
      }
    },
    'typeSearch': function() {
      if(this.buscarProdutoItem.length >= 3) {
        this.buscarProduto(this.buscarProdutoItem);
      }
    },
    'search': function() {
      if(this.search.length == 0) {
        this.itens = [];
      }
    },
    'dados.oPFrete.retiraLoja': function() {
      if(this.dados.oPFrete.retiraLoja == false) {
        this.dados.oPFrete.retiraLojaT = null;
        this.dados.oPFrete.retiraLojaD = null;
      }
    },
    'dados.oPFrete.entrega': function() {
      if(this.dados.oPFrete.entrega == false) {
        this.dados.oPFrete.entregaT = null;
        this.dados.oPFrete.entregaD = null;
        this.dados.oPFrete.valorFrete = null;
        this.somaTotal();
      }
    },
  },
  beforeUpdate() {
    if(this.produtos.length > 0) {
      this.calcTax();
    }
  },
  created() {
    if (this.checkIsEmpty(this.token)) {
      this.$router.push({ name: 'area-restrita' });
    }
  },
  methods: {
    modalBucarProdutos() {
      this.$bvModal.show('modalBuscarProdutos'); 
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.value);
      this.makeToast('Sucesso!', 'Copiado com sucesso!', 'success');
    },
    buscarProduto(text) {
      this.cancel();
      let axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };

      const data = {
        text: text,
        construp_user_id: this.dadosUsuario.construp_user_id,
        type: this.typeSearch,
        cancelToken: axiosSource.token
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('balconista/buscarProduto', data)
        .then((response) => {
          this.itens = response.data.data;
          this.$store.dispatch('endLoader');
        })
        .catch(() => {
        })
    },
    buscarProdutoCod(cod) {
      if(!cod)return

      const data = {
        text: cod,
        cod_int: true,
        construp_user_id: this.dadosUsuario.construp_user_id,
        type: this.typeSearch
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('balconista/buscarProduto', data)
        .then((response) => {
          if(response.data.data != null) {
            this.formatItem(response.data.data)
          } else {
            this.makeToast('Opss!', 'Produto não encontrado para o cód. '+cod, 'danger');
          }
          this.$store.dispatch('endLoader');
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
        })
    },
    cancel() {
      if (this.request) this.request.cancel();
    },
    buscarCliente(cliente=false) {
      this.limparOrcamento();
      this.produtos = [];      

      const data = {
        email: cliente == true ? 'orcamentosemcliente@gmail.com' : this.emailBusca,
        tipoBusca: cliente == true ? 'email' : this.tipoBuscaCliente,
        construp_user_id: cliente == true ? 3848 : this.dadosUsuario.construp_user_id
      }

      this.novaConta = false;

      this.$store.dispatch('startLoader');
      this.$store.dispatch('balconista/buscarCliente', data)
        .then((response) => {
          if(response.data.data.cliente == true) {
            if(response.data.data.dados && response.data.data.dados.length > 0) {
              this.clientes = response.data.data.dados;
              this.$bvModal.show('modalClientes');
            } else {
              this.dados.email = response.data.data.email;
              this.dados.user_id = response.data.data.user_id;
            }
            this.adicionarProduto();
          } else {
            this.novaConta = true;
            this.makeToast('Oopss', 'Cliente não encontrado!', 'danger');
          }
        })
        .catch(() => {
          this.makeToast('Oopss', 'Cliente não encontrado!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    addClienteSearch(item) {
      this.emailBusca = item.email
      this.dados.email = item.email;
      this.dados.user_id = item.user_id;
      this.$bvModal.hide('modalClientes');
      this.clientes = [];
    },
    validarOrcamento() {
      let valid = false;

      this.limparErro();
      const priceProdutos = this.produtos.filter(i => i.price == '0,00' || i.price == null || i.price == '');
      if(priceProdutos.length > 0) {
        this.makeToast('Oopss', 'Informe o preço de todos os itens!', 'danger');
        valid = true;
      }

      if(this.pix == '' && this.boleto == '' && this.cartao == '') {
        this.makeToast('Oopss', 'Informe pelo menos um meio de pagamento!', 'danger');
        valid = true;
      }

      if(this.dados.oPFrete.retiraLoja == false && this.dados.oPFrete.entrega == false) {
        this.makeToast('Oopss', 'Informe pelo menos um meio de entrega!', 'danger');
        valid = true;
      }

      if((this.dados.oPFrete.retiraLoja == true) && 
        (this.dados.oPFrete.retiraLojaT == null || this.dados.oPFrete.retiraLojaD == null || this.dados.oPFrete.retiraLojaT == '' || this.dados.oPFrete.retiraLojaD == '')) {
        this.makeToast('Oopss', 'Informe o prazo para retirada em loja após o pagamento!', 'danger');
        valid = true;
      }

      if((this.dados.oPFrete.entrega == true) && 
        (this.dados.oPFrete.entregaD == null || this.dados.oPFrete.entregaT == null || this.dados.oPFrete.entregaD == '' || this.dados.oPFrete.entregaT == '')) {
        this.makeToast('Oopss', 'Informe o prazo para para entrega após o pagamento!', 'danger');
        valid = true;
      }

      if((this.dados.oPFrete.entrega == true) && 
        (this.dados.oPFrete.cep == null || this.dados.oPFrete.endereco == null || this.dados.oPFrete.numero == null ||
        this.dados.oPFrete.bairro == null || this.dados.oPFrete.cidade == null || this.dados.oPFrete.uf == null)) {
        this.makeToast('Oopss', 'Informe o endereco de entrega!', 'danger');
        valid = true;
      }
      this.camposErro();

      return valid;
    },
    camposErro() {
      if(this.pix == '' && this.boleto == '' && this.cartao == '' && this.pagamentoEntrega == '') {
        this.error.pagamento = true;
      }

      if(this.dados.oPFrete.retiraLoja == false && this.dados.oPFrete.entrega == false) {
        this.error.retiraLojaT = true;
        this.error.retiraLojaD = true;
        this.error.entregaT = true;
        this.error.entregaD = true;
      } else {
        if((this.dados.oPFrete.retiraLoja == true) && (this.dados.oPFrete.retiraLojaD == null || this.dados.oPFrete.retiraLojaD == '')) {
          this.error.retiraLojaD = true;
        }

        if((this.dados.oPFrete.retiraLoja == true) && (this.dados.oPFrete.retiraLojaT == null || this.dados.oPFrete.retiraLojaT == '' )) {
          this.error.retiraLojaT = true;
        }

        if((this.dados.oPFrete.entrega == true) && (this.dados.oPFrete.entregaT == null || this.dados.oPFrete.entregaT == '')) {
          this.error.entregaT = true;
        }

        if((this.dados.oPFrete.entrega == true) && (this.dados.oPFrete.entregaD == null || this.dados.oPFrete.entregaD == '' )) {
          this.error.entregaD = true;
        }
      }

      if((this.dados.oPFrete.entrega == true) &&  (this.dados.oPFrete.cep == null)) {
        this.error.cep = true;
      }

      if((this.dados.oPFrete.entrega == true) &&  (this.dados.oPFrete.endereco == null)) {
        this.error.endereco = true;
      }

      if((this.dados.oPFrete.entrega == true) &&  (this.dados.oPFrete.bairro == null)) {
        this.error.bairro = true;
      }

      if((this.dados.oPFrete.entrega == true) &&  (this.dados.oPFrete.numero == null)) {
        this.error.numero = true;
      }
    },

    buscarDetalhesGerais(productId, productModal) {
      this.$store.dispatch('startLoader');

      const data = {
        productId: productId,
        lojistaId: this.dadosUsuario.construp_user_id
      }

      this.productModal = productModal;

      this.$store.dispatch('shopkeeper/getDetalhesProdutoGeral', data)
        .then((response) => {
          this.detalhesP.fichas = response.data.ficha;
          this.detalhesP.fotos = response.data.fotos;
          this.detalhesP.produto = response.data.produto;
          this.$refs['detalhesProduto'].show();
        })
        .catch(() => {
          this.makeToast(
            'Opss',
            'Erro ao buscar detalhes do produto!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    
    dateFormat(){
      this.dados.validade = null;
      const yearUser = this.validOrcamentDate.slice(0,4);
      const monthUser = this.validOrcamentDate.slice(5,7);
      const dayUser = this.validOrcamentDate.slice(8,10);

      const dateSelect = new Date(`${monthUser}/${dayUser}/${yearUser} ${this.validOrcamentHour}`);
      const dateNow = new Date();

      if(dateSelect.getTime() > dateNow.getTime()){
        this.dados.validade = `${dayUser}/${monthUser}/${yearUser} - ${this.validOrcamentHour}`;
      }
    },

    finalizar() { 
      if(!this.validOrcamentDate){
        this.makeToast('Erro', 'A data é obrigatório!', 'danger');
        return;
      }
      
      if(!this.validOrcamentHour){
        this.makeToast('Erro', 'A hora é obrigatório!', 'danger');
        return;
      }

      this.dateFormat();
      
      if(!this.dados.validade){
        this.makeToast('Erro', 'A data e hora não podem ser menor que a atual!', 'danger');
        return;
      }

      if(this.validarOrcamento() == true) {
        return;
      }

      const nomeLojista = this.dadosUsuario.lojista.nome_fantasia.toLowerCase();

      this.dados.balconista_id = this.dadosUsuario.id;
      this.dados.lojista_id = this.dadosUsuario.construp_user_id;
      this.dados.link = nomeLojista.replace(/\s/g, "-");

      const tipoPagamento = {
        pix: this.pix,
        boleto: this.boleto,
        cartao: this.cartao,
        entrega: this.pagamentoEntrega,
        desconto: {
          pix: this.desconto.pix,
          boleto: this.desconto.boleto,
          cartao: this.totalParcelas,
          entrega: this.desconto.entrega,
        },
      }

      this.dados.oPgamento.tipos = tipoPagamento;

      const itens = this.produtos.map((i) => {
        i.results = null;
        return i;
      });

      this.dados.itens = itens;

      this.$store.dispatch('startLoader');
      this.$store.dispatch('balconista/finalizarOrcamento', this.dados)
        .then((response) => {
          this.makeToast('Sucesso', 'Orçamento realizado com sucesso!', 'success');
          this.value = response.data.data.url;
          this.$bvModal.show('linkPagamentoModal');
          this.emailBusca = '';
          this.limparOrcamento();
        })
        .catch(() => {
          this.makeToast('Oopss', 'Erro ao realizar orçamento!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    salvarCliente() {
      if(this.Fields.email == '' || this.Fields.nome == '' || this.Fields.sobrenome == '' || this.Fields.whatsapp == '' || this.Fields.cpf == '') {
         this.makeToast('Oopss', 'Informe todos os campos para criar o cliente!', 'danger');
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('balconista/salvarCliente', this.Fields)
        .then((response) => {
           if(response.data.data.cliente == true) {
            this.dados.email = this.Fields.email;
            this.dados.user_id = response.data.data.user_id;

            if(response.data.data.cadastrado == true) {
              this.makeToast('Sucesso', 'Cliente já cadastrado!', 'success');
            }

            this.$bvModal.hide('novaContaCliente')
            this.novaConta = false;

            this.adicionarProduto();
          } else {
            this.novaConta = true;
            this.makeToast('Oopss', 'Não foi possível salvar cliente!', 'danger');
          }
        })
        .catch(() => {
          this.makeToast('Oopss', 'Não foi possível salvar cliente!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    formatName(item) {
      if(item.type == 1) {
        return item.first_name+' '+item.last_name
      } else if(item.type == 2) {
        return item.name;
      } else if(item.type == 3) {
        return item.nome_fantasia;
      }
    },
    buscarCep() {
      var cep = this.dados.oPFrete.cep.replace(/[^0-9]/g, '');
      if(cep.length == 8) {
        this.$store.dispatch('startLoader');
        axios.get(`https://viacep.com.br/ws/${cep}/json`)
        .then((response) => {
          if(response.data) {
            var end = response.data;
            this.dados.oPFrete.endereco = end.logradouro;
            this.dados.oPFrete.bairro = end.bairro;
            this.dados.oPFrete.cidade = end.localidade;
            this.dados.oPFrete.uf = end.uf;
            this.dados.oPFrete.numero = null;
            this.dados.oPFrete.complemento = '';
          } else {
            this.makeToast('Oopss', 'CEP invalido!', 'danger');
          }
        })
        .catch(() => {
          this.makeToast('Oopss', 'CEP invalido!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
      } else {
        this.makeToast('Oopss', 'CEP invalido!', 'danger');
      }
    },
    formPayments(value) {
      let checkboxPix = document.getElementById('checkboxPix');
      let checkboxBoleto = document.getElementById('checkboxBoleto');
      let checkboxCartao = document.getElementById('checkboxCartao');
      let checkboxEntrega = document.getElementById('checkboxEntrega');

      if (value === 'P') {
        if (checkboxPix.checked) {
          this.pix = 'P';
        } else {
          this.pix = '';
        }
      }

      if (value === 'B') {
        if (checkboxBoleto.checked) {
          this.boleto = 'B';
        } else {
          this.boleto = '';
        }
      }

      if (value === 'C') {
        if (checkboxCartao.checked) {
          if(this.totalParcelas == 0){
            this.totalParcelas = 1;
          }
          this.cartao = 'C';
        } else {
          this.cartao = '';
          this.totalParcelas = 0;
        }
      }

      if (value === 'E') {
        if (checkboxEntrega.checked) {
          this.pagamentoEntrega = 'E';
        } else {
          this.pagamentoEntrega = '';
        }
      }
    },
    selectQtdParcelas(type = '') {
      if(this.totalParcelas > 0 && this.cartao == '' && type == 'prod') {
        this.cartao = 'C'
        let checkboxCartao = document.getElementById('checkboxCartao');
        checkboxCartao.checked = true;
      }
    },
    deleteItem(i) {
      if(this.produtos.length > 1) {
        this.produtos.splice(i, 1);
        this.somaTotal();
      } else {
        this.makeToast('Oopss', 'Orçamento precisa de pelo menos 1 item!', 'danger');
      }
    },
    validQtd(i) {
      if(this.produtos[i].qtd < 1) {
        this.produtos[i].qtd = 1;
      }
      this.validPrice(i);
    },
    somaTotal() {
      this.dados.oPgamento.subTotal = null;
      this.dados.oPgamento.total = null;

      this.produtos.map((i) => {
        var price = null;
        if(isNaN(i.subtotal)){
          var p = i.subtotal.replace(/[^0-9]/g, '');
          price = parseFloat(p);
        } else {
          price = i.subtotal;
        }

        this.dados.oPgamento.subTotal = this.dados.oPgamento.subTotal + price;
      })

      if(this.dados.oPFrete.entrega == true) {
        var frete = null;
        if(isNaN(this.dados.oPFrete.valorFrete)) {
          frete = this.dados.oPFrete.valorFrete.replace(/[^0-9]/g, '');
        } else {
          frete = parseFloat(this.dados.oPFrete.valorFrete);
        }
        this.dados.oPgamento.total = this.dados.oPgamento.subTotal + parseFloat(frete);
      } else {
        this.dados.oPgamento.total = this.dados.oPgamento.subTotal;
      }
    },
    validPrice(i) {
      if(this.produtos[i].price != null) {
        this.produtos[i].subtotal = this.produtos[i].qtd * parseFloat(this.produtos[i].price.replace(/[^0-9]/g, ''));
      } else {
        this.produtos[i].subtotal = null;
      }
      this.somaTotal();
    },
    calcTax() {
      const taxaPix = 0.50
      const taxaBoleto = 1.89

      let totalBruto = this.dados.oPgamento.subTotal / 100;
      let descontoPix = totalBruto * (this.desconto.pix / 100);
      let pixComDesconto = totalBruto - descontoPix;
      this.pixTotal = pixComDesconto - taxaPix;
      this.taxa.pix = taxaPix;
      this.pixTotal = this.pixTotal.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      this.taxa.pix = this.taxa.pix.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });

      let descontoBoleto = totalBruto * (this.desconto.boleto / 100);
      let boletoComDesconto = totalBruto - descontoBoleto;
      this.boletoTotal = boletoComDesconto - taxaBoleto;
      this.taxa.boleto = taxaBoleto;
      this.boletoTotal = this.boletoTotal.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      this.taxa.boleto = this.taxa.boleto.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });

      let taxaCartao = 0.0235;
      let totalParcial = totalBruto - totalBruto * taxaCartao - 0.3;
      this.cartaoTotal = totalParcial;
      this.taxa.cartao = totalBruto * taxaCartao + 0.3;
      this.cartaoParcelado = this.cartaoTotal / this.totalParcelas;
      this.cartaoTotal = this.cartaoTotal.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      this.taxa.cartao = this.taxa.cartao.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      this.cartaoParcelado = this.cartaoParcelado.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
    formatItem(item) {
      this.produtos[this.iSelected].product_id = item.id;
      this.produtos[this.iSelected].product = item.produto;
      this.produtos[this.iSelected].origem = item.origem;
      this.produtos[this.iSelected].bar_code = item.codbar;
      this.produtos[this.iSelected].marca = item.marca;
      this.produtos[this.iSelected].cod_int = item.cod_int;
      this.produtos[this.iSelected].unidade = item.unidade;
      this.produtos[this.iSelected].price = item.price_sales_format_1;
      this.produtos[this.iSelected].img = item.produto_fotos[0].foto_png;

      this.validPrice(this.iSelected);

      this.$bvModal.hide('modalBuscarProdutos');
    },
    addCliente(validEmail) {
      this.Fields = {
        email: '',
        cpf: '',
        nome: '',
        sobrenome: '',
        whatsapp: '',
        clerk_id: this.dadosUsuario.id,
        contrup_lojista_id: this.dadosUsuario.construp_user_id
      }

      this.desativarEmail = validEmail;

      this.$bvModal.show('novaContaCliente')
    },
    adicionarProduto() {
      this.produtos.push({
        product: '',
        marca: '',
        cod_int: '',
        qtd: 1,
        price: null,
        unidade: null,
        bar_code: null,
        img: null,
        type: 'geral',
        origem: '',
        price_discont: null,
        subtotal: null,
        altQtd: false,
        qtdMax: null
      });
    },
    removeSpecialChars(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
    formatImg(origem, link) {
      if(origem == 'Belenus') {
        return 'https://storage.googleapis.com/fotos-prd/'+link;
      } else {
        return process.env.VUE_APP_FOTOS_URL+link;
      }
    },
    formatImgModal(origem, link, nome) {
      if(origem == 'Belenus') {
        this.modalImgNome = nome;
        this.modalImg = 'https://storage.googleapis.com/fotos-prd/'+link;
      } else {
        this.modalImgNome = nome;
        this.modalImg = process.env.VUE_APP_FOTOS_URL+link;
      }
      this.$bvModal.show('modalImgProduto');      
    },
    // converterCoin(coin) {
    //   if(coin != null) {
    //     const text = coin.toString();
    //     return text.slice(0, -2);
    //   }
    // },
    checkIsEmpty(value) {
      if (value === '' || value === null || value === 'null' || value === 'undefined') {
        return true;
      }
      return false;
    },
    limparOrcamento() {
      this.dados.email = null;
      this.dados.user_id = null;
      this.dados.oPgamento.total = null;
      this.dados.oPgamento.subTotal = null;
      this.dados.oPgamento.tipos = {};
      this.dados.oPFrete.retiraLoja = false;
      this.dados.oPFrete.retiraLojaD = null;
      this.dados.oPFrete.retiraLojaT = null;
      this.dados.oPFrete.entrega = null;
      this.dados.oPFrete.entregaD = null;
      this.dados.oPFrete.entregaT = null;
      this.dados.oPFrete.valorFrete = null;
      this.dados.oPFrete.cep = null;
      this.dados.oPFrete.endereco = null;
      this.dados.oPFrete.bairro = null;
      this.dados.oPFrete.complemento = null;
      this.dados.oPFrete.numero = null;
      this.dados.oPFrete.cidade = null;
      this.dados.oPFrete.uf = null;
      this.dados.itens = [];
    },
    limparErro() {
      this.error = {
        retiraLojaT: false,
        retiraLojaD: false,
        entregaT: false,
        entregaD: false,
        cep: false,
        endereco: false,
        bairro: false,
        numero: false,
        pagamento: false
      }
    },
    handleEnterKey(event) {
      event.preventDefault(); // Evita que a tecla "Enter" gere uma quebra de linha
      const inputs = document.getElementsByTagName('input');
      const currentIndex = Array.prototype.indexOf.call(inputs, event.target);
      const nextInput = inputs[currentIndex + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
  },
};
</script>

<style scoped>
.required {
  border: 1px solid red;
}
.opcional {
  font-size: 12px;
  color: #7a7a7a;
  margin-left: 5px;
}
.opcionalSelect {
  color: #7a7a7a;
}
.itemList {
  color: rgb(255, 127, 0);
  font-size: 22px;
  font-weight: 900;
}
.alinharCentro {
  text-align: center;
  justify-content: center;
  align-items: flex-end;
  display: flex;
}
.alingImg {
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
}
.btn-search {
  position: absolute;
  top: 33px;
  right: 10px;
  background: transparent;
  border-left: 1px solid #ced4da;
  border-right: none;
  border-top: none;
  height: 37px;
  border-bottom: none;
}
.btn-finalizar {
  background-color: #28a745;
  border: none;
  border-radius: 3px;
  height: 40px;
  width: 200px;
  color: #FFF;
}
.btn-finalizar:hover {
  background-color: #28a746dc;
}
.btn-add-cliente {
  background-color: #28a745;
  border: none;
  border-radius: 3px;
  height: 40px;
  width: 100%;
  color: #FFF;
}
.btn-add-cliente:hover {
  background-color: #28a746dc;
}
.btn-add-item {
  background-color: #222;
  border: none;
  border-radius: 3px;
  height: 40px;
  width: 170px;
  color: #FFF;
}
.btn-add-item:hover {
  background-color: #222222e5;
}
.btn-trash-item {
  background-color: #dc3545;
  border: none;
  border-radius: 3px;
  height: 40px;
  width: 100%;
  color: #FFF;
}
.btn-trash-item:hover {
  background-color: #dc3546c7;
}
.btn-trash-item-disabled {
  background-color: #dc35466c;
  border: none;
  border-radius: 3px;
  height: 40px;
  width: 100%;
  color: #FFF;
}
.btn-send-payment {
  margin-top: 20px;
  width: 100%;
  padding: 15px 0;
  background: #3fc583;
  color: #FFF;
  font-weight: bold;
  font-size: 18px;
  border: none;
  border-radius: 3px;
}
.arrow-line-down {
  z-index: 99;
  display: flex;
  justify-content: flex-end;
  margin-top: -40px;
}
.arrow-line-up {
  z-index: 99;
  display: flex;
  justify-content: flex-end;
  margin-top: -28px;
}
.cursor-pointer {
  cursor: pointer;
}
.input-select{
  background-color: #28a745;
  text-align: center;
color: white;
  
}
.limparOrcamento {
  float: right;
  cursor: pointer;
  color: red;
}
.btn-add-produto {
  background-color: #222;
  color: #FFF;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
}
.modalImg {
  width: 100%;
}
/* .colorCoin {
  color: #28a745;
  border: 1px solid #28a745;
} */
.size-img {
  width: 50px;
  padding: 0;
}
.col-img {
  margin-left: -25px;
}
.timer-heigth{
  margin-top: 30px;
}
</style>
